/**
 * Maps component aiContext IDs to feature docs and suggested questions.
 * Used by SectionHeading's Sparkles icon to pre-load contextual chat.
 */
export const COMPONENT_CONTEXT = {
  'practice-pulse.kpi-grid': {
    featureId: 'FPP.2',
    suggested: [
      'What are the Key Indicators?',
      'How do I customize my KPIs?',
      'What do the trend arrows mean?',
    ],
  },
  'practice-pulse.domain-health': {
    featureId: 'FPP.1',
    suggested: [
      'What does each domain health dot mean?',
      'How are domain headlines selected?',
      'What triggers a red domain indicator?',
    ],
  },
  'practice-pulse.ops-ribbon': {
    featureId: 'FPP.3',
    suggested: [
      'What is the OpsRibbon?',
      'How are overdue tasks counted?',
      'What does the compliance bar show?',
    ],
  },
  'staffing.coverage-status': {
    featureId: 'FST.2',
    suggested: [
      'What does coverage status mean?',
      'How are staffing thresholds configured?',
      'What triggers a critical role gap alert?',
    ],
  },
  'staffing.ot-exposure': {
    featureId: 'FST.6',
    suggested: [
      'How is OT exposure calculated?',
      'What is the configurable OT threshold?',
    ],
  },
  'staffing.credential-tracking': {
    featureId: 'FST.4',
    suggested: [
      'How does credential tracking work?',
      'What are the 5 alert statuses?',
      'How do I upload credential data?',
    ],
  },
  'finance.ar-aging': {
    featureId: 'FFT.3',
    suggested: [
      'What does AR aging measure?',
      'What are the aging buckets?',
      'How is revenue leakage detected?',
    ],
  },
  'quality.compliance-tracker': {
    featureId: 'FQR.2',
    suggested: [
      'What compliance items are tracked?',
      'How are compliance deadlines calculated?',
    ],
  },
  'consumer.satisfaction-scores': {
    featureId: 'FCI.1',
    suggested: [
      'How are satisfaction scores calculated?',
      'What survey data feeds this?',
      'How do I upload CAHPS data?',
    ],
  },
  'access.appointment-availability': {
    featureId: 'FSA.2',
    suggested: [
      'What does appointment availability measure?',
      'How is third-next-available calculated?',
    ],
  },
  'pm.task-library': {
    featureId: 'FPM.1',
    suggested: [
      'What are the 33 preloaded tasks?',
      'How do I create custom tasks?',
      'How do domain-specific tasks work?',
    ],
  },
  'pm.priority-queue': {
    featureId: 'FPM.4',
    suggested: [
      'How is the priority queue ordered?',
      'What are the queue views (list, kanban, calendar)?',
    ],
  },
  'pm.checklist-engine': {
    featureId: 'FPM.4',
    suggested: [
      'What checklists are available?',
      'How do recurring checklists work?',
      'Can I create custom checklists?',
    ],
  },
  'network-pulse.overview': {
    featureId: 'FNP.1',
    suggested: [
      'What is Network Pulse?',
      'How do I compare practices?',
      'What metrics are shown at the network level?',
    ],
  },
  'population-health.overview': {
    featureId: 'FPH.1',
    suggested: [
      'What population health metrics are tracked?',
      'How is quality reporting calculated?',
    ],
  },
};

/**
 * Get context for a component AI identifier.
 */
export function getComponentContext(aiContext) {
  return COMPONENT_CONTEXT[aiContext] ?? null;
}
